export const ROLES: string[] = ["Admin", "SuperAdmin"];
